
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-black border-t border-white/10 overflow-hidden">
      {/* Subtle bottom glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-32 bg-[#F6B766]/5 blur-3xl"></div>

      <div className="relative z-10 container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-black rounded-lg border border-[#F6B766]/30">
                <img
                  src="https://public.readdy.ai/ai/img_res/256ede9f9b173fcf539dd5f4762bc6bd.jpg"
                  alt="MondayPawn Logo"
                  className="w-8 h-8 object-cover rounded opacity-90"
                />
              </div>
              <span className="text-2xl font-light text-white">MondayPawn</span>
            </div>
            <p className="text-white/50 font-light leading-relaxed">
              숨은 고수가 만드는 게임 트레일러<br/>
              Seoul, South Korea
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-medium mb-6 text-lg">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-white/50 hover:text-[#F6B766] transition-colors font-light cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/50 hover:text-[#F6B766] transition-colors font-light cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-medium mb-6 text-lg">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-white/50 font-light">
                <i className="ri-mail-line text-[#F6B766] mr-3 mt-1"></i>
                <span>haddon@mondaypawn.com</span>
              </li>
              <li className="flex items-start text-white/50 font-light">
                <i className="ri-map-pin-line text-[#F6B766] mr-3 mt-1"></i>
                <span>Seoul, South Korea</span>
              </li>
              <li className="flex items-start text-white/50 font-light">
                <i className="ri-user-line text-[#F6B766] mr-3 mt-1"></i>
                <span>Bohyun Kim, Founder</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-sm font-light">
              © {currentYear} MondayPawn. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/40 hover:text-[#F6B766] text-sm transition-colors font-light cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
